/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSwipeLeft = createReactComponent("swipe-left", "IconSwipeLeft", [
  ["path", { d: "M20 12a4 4 0 1 0 -8 0a4 4 0 0 0 8 0z", key: "svg-0" }],
  ["path", { d: "M12 12h-8", key: "svg-1" }],
  ["path", { d: "M7 15l-3 -3l3 -3", key: "svg-2" }]
]);

export { IconSwipeLeft as default };
//# sourceMappingURL=IconSwipeLeft.js.map
